/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as IdentityDefs from './defs.defs.js'

const $nsid = 'com.atproto.identity.refreshIdentity'

export { $nsid }

/** Request that the server re-resolve an identity (DID and handle). The server may ignore this request, or require authentication, depending on the role, implementation, and policy of the server. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({ identifier: l.string({ format: 'at-identifier' }) }),
  l.payload(
    'application/json',
    l.ref<IdentityDefs.IdentityInfo>((() => IdentityDefs.identityInfo) as any),
  ),
  ['HandleNotFound', 'DidNotFound', 'DidDeactivated'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
